import React from 'react';

import { reloadStatsState, reloadFeedbackList } from 'actions/continuousFeedback';
import { connect, useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { selectLoggedInEmployeeData } from 'selectors/loggedInEmployee';

import { FEEDBACK_FORM_TYPE } from 'constants/ProjectConstants';
import { getQueryParams, pushBackFeedbackParams, pushFeedbackParams } from 'constants/helper';

import { BottomDrawer } from 'uiToolkitV1/BottomDrawer';

import RequestFeedbackNew from './Drawers/RequestFeedback/RequestFeedback';
import RequestedFeedbackNew from './Drawers/RequestedFeedback/RequestedFeedback';
import ShareFeedbackNew from './Drawers/ShareFeedback/ShareFeedback';
import {
  setClearFillRequestedFeedbackData,
  setClearProvidedFeedbackData,
  setClearRequestedFeedbackData,
} from './Drawers/slice/feedbackSlice';
import FeedbackListSidepanel from './FeedbackListSidepanel';
import RequestedFeedbackFullCommentDrawer from './RequestedFeedbackFullCommentDrawer';
import SharedOrReceivedFullCommentDrawer from './SharedOrReceivedFullCommentDrawer';
import ShowRequestedFeedback from './ShowRequestedFeedback';
import ShowSharedOrReceivedFeedback from './ShowSharedOrReceivedFeedback';
import FeedbackBottomDrawer from './common/FeedbackBottomDrawer';

const ContinuousFeedbackSidebar = ({ loggedInEmployee, continuousFeedback }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { location } = history;
  const queryString = location.search;

  const { showFeedback, feedbackId, formType, tab } = getQueryParams(queryString);
  const open = showFeedback === 'true' && typeof formType === 'string';

  const handleClose = () => {
    pushBackFeedbackParams(history);
  };

  const handleCloseNewPanels = () => {
    pushBackFeedbackParams(history);
    setTimeout(() => {
      dispatch(setClearRequestedFeedbackData());
      dispatch(setClearProvidedFeedbackData());
      dispatch(setClearFillRequestedFeedbackData());
    }, 500);
  };

  const handleReloadStats = () => {
    dispatch(reloadStatsState());
    continuousFeedback?.primaryCallbackFunction?.();
  };

  const handleResetData = ({ reloadType }) => {
    dispatch(reloadFeedbackList({ reloadType }));
  };

  const handleOpenShareForm = () => {
    pushFeedbackParams({ history, formType: FEEDBACK_FORM_TYPE.PROVIDED, newForm: true });
  };
  const handleOpenRequestForm = () => {
    pushFeedbackParams({ history, formType: FEEDBACK_FORM_TYPE.REQUESTED, newForm: true });
  };

  if (formType === FEEDBACK_FORM_TYPE.SHOW_REQUESTED) {
    return (
      <FeedbackBottomDrawer open={open} onClose={handleClose} heading="Request from">
        <RequestedFeedbackFullCommentDrawer handleClose={handleClose} feedbackId={feedbackId} formType={formType} />
      </FeedbackBottomDrawer>
    );
  }

  if (formType === FEEDBACK_FORM_TYPE.SHOW_PROVIDED) {
    return (
      <FeedbackBottomDrawer open={open} onClose={handleClose}>
        <SharedOrReceivedFullCommentDrawer handleClose={handleClose} postId={feedbackId} formType={formType} />
      </FeedbackBottomDrawer>
    );
  }

  if (formType === FEEDBACK_FORM_TYPE.SHOW_RECEIVED) {
    return (
      <FeedbackBottomDrawer open={open} onClose={handleClose}>
        <SharedOrReceivedFullCommentDrawer handleClose={handleClose} postId={feedbackId} formType={formType} />
      </FeedbackBottomDrawer>
    );
  }
  return (
    <BottomDrawer isOpen={open} onClose={handleCloseNewPanels} blockScrollOnMount={false} trapFocus={false}>
      {formType === FEEDBACK_FORM_TYPE.REQUESTED && (
        <RequestFeedbackNew
          handleClose={handleClose}
          handleResetData={handleResetData}
          handleReloadStats={handleReloadStats}
          loggedInEmployee={loggedInEmployee}
        />
      )}

      {formType === FEEDBACK_FORM_TYPE.PROVIDED && (
        <ShareFeedbackNew
          handleClose={handleClose}
          handleResetData={handleResetData}
          handleReloadStats={handleReloadStats}
          loggedInEmployee={loggedInEmployee}
        />
      )}

      {formType === FEEDBACK_FORM_TYPE.SHOW_PROVIDED && (
        <ShowSharedOrReceivedFeedback handleClose={handleClose} isShared />
      )}

      {formType === FEEDBACK_FORM_TYPE.SHOW_RECEIVED && (
        <ShowSharedOrReceivedFeedback handleClose={handleClose} isShared={false} />
      )}

      {formType === FEEDBACK_FORM_TYPE.SHOW_REQUESTED && (
        <ShowRequestedFeedback
          handleClose={handleClose}
          feedbackId={feedbackId}
          loggedInEmployee={loggedInEmployee}
          handleResetData={handleResetData}
          handleReloadStats={handleReloadStats}
        />
      )}
      {formType === FEEDBACK_FORM_TYPE.PROVIDING_REQUESTED && (
        <RequestedFeedbackNew
          handleClose={handleClose}
          feedbackId={feedbackId}
          loggedInEmployee={loggedInEmployee}
          handleResetData={handleResetData}
          handleReloadStats={handleReloadStats}
        />
      )}
      {formType === FEEDBACK_FORM_TYPE.LIST_FEEDBACKS && (
        <FeedbackListSidepanel
          handleClose={handleClose}
          handleOpenShareForm={handleOpenShareForm}
          handleOpenRequestForm={handleOpenRequestForm}
          defaultTab={tab}
        />
      )}
    </BottomDrawer>
  );
};

const mapStateToProps = (state) => ({
  loggedInEmployee: selectLoggedInEmployeeData(state),
  continuousFeedback: state.continuousFeedback,
});

export default connect(mapStateToProps, {})(ContinuousFeedbackSidebar);
